export default {
  'pages.layouts.userLayout.title': 'Hi~',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.workbench.link': 'workbench',
  'pages.workbench.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage':
    'Umi ui is now released, workbench to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
  'pages.template.title': 'Enterprise Knowledge Graph',
  'pages.template.submit.success': 'Form submitted successfully!',
  'pages.template.form.name': 'Name',
  'pages.template.form.email': 'Email',
  'pages.template.form.department': 'Department',
  'pages.template.form.joinDate': 'Join Date',
  'pages.template.form.remarks': 'Remarks',
  'pages.template.placeholder.name': 'Please enter name',
  'pages.template.placeholder.email': 'Please enter email',
  'pages.template.placeholder.department': 'Please select a department',
  'pages.template.placeholder.remarks': 'Please enter remarks',
  'pages.template.validation.nameRequired': 'Please enter name',
  'pages.template.validation.emailRequired': 'Please enter email',
  'pages.template.validation.emailInvalid': 'Invalid email format',
  'pages.template.validation.departmentRequired': 'Please select a department',
  'pages.template.validation.joinDateRequired': 'Please select a join date',
  'pages.template.department.tech': 'Technology',
  'pages.template.department.sales': 'Sales',
  'pages.template.department.hr': 'Human Resources',
  'pages.template.department.finance': 'Finance',
  'pages.template.action.submit': 'Submit',
  'pages.template.action.reset': 'Reset',
};
